import React, { PureComponent } from 'react'
import { observer } from 'mobx-react'
import Modal from '../../../UniformComponents/Modal'
import ModalHeader from '../../../UniformComponents/ModalHeader'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Button from '../../../UniformComponents/Button'
import Select from '../../form/Select'
import Checkbox from '../../form/Checkbox'

@observer
class WidgetType extends PureComponent {
    changeWidgetType =(value) => {
        const { dashboardWizardStore } = this.props
        const { changeWidgetType } = dashboardWizardStore
        changeWidgetType(value)
    }

    radioButton = (icon, title, subTitle, key) => {
        const { dashboardWizardStore } = this.props
        const { newWidget, widgetType } = dashboardWizardStore
        const { widgetBasis } = newWidget
        return (
            <div
                className={`largeRadio ${widgetType === key ? 'active' : ''}`}
                onClick={() => this.changeWidgetType(key)}
                onKeyDown={() => this.changeWidgetType(key)}
                role="button"
                tabIndex={0}
            >
                <div className="iconBox">
                    <div className="iconBorder">
                        <i className={icon} />
                    </div>
                </div>
                <div className="title">
                    {title}
                </div>
                <div className="subTitle">
                    {subTitle}
                </div>
                <Checkbox
                    name={key}
                    onBlur={(v) => this.changeWidgetType(v.name)}
                    checked={widgetType === key}
                />
            </div>
        )
    }

    render() {
        const { dashboardWizardStore } = this.props
        const { showWidgetType, toggleShowWidgetType } = dashboardWizardStore
        return (
            <Modal show={showWidgetType} onClose={() => toggleShowWidgetType(false)} cssClass="dashboardCreationWizard widgetType">
                <div className="gettingStarted">
                    <ModalHeader cssClass="header">
                        <div className="title">
                            Getting started...
                        </div>
                        <div className="subTitle">
                            Select your widget type
                        </div>
                    </ModalHeader>
                    <div className="body">
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            {this.radioButton(
                                'fa-light fa-chart-simple',
                                'Single Metric',
                                'Base the widget on data formed from question responses.',
                                'single',
                            )}
                            {this.radioButton(
                                'fa-light fa-chart-simple',
                                'Multi Metric',
                                'Base the widget on data formed from question responses.',
                                'multi',
                            )}
                            {this.radioButton(
                                'fa-light fa-chart-simple',
                                'Aggregated Metric',
                                'Base the widget on data formed from question responses.',
                                'aggregated',
                            )}
                            {this.radioButton(
                                'fa-light fa-chart-simple',
                                'Quadrant analysis',
                                'Base the widget on data formed from question responses.',
                                'quadrantAnalysis',
                            )}
                            {/* <Select
                                label="Widget Type"
                                name="widgetType"
                                options={[
                                    { label: 'Single Metric', value: 'single' },
                                    { label: 'Multi Metric', value: 'multi' },
                                    { label: 'Aggregated Metric', value: 'aggregated' },
                                    { label: 'Quadrant analysis', value: 'quadrant' },
                                ]}
                                onBlur={this.changeWidgetType}
                            /> */}
                        </div>
                    </div>
                    <ModalFooter>
                        <Button
                            label="Cancel"
                            cssClass="tertiary regular"
                            style={{ marginRight: '25px', width: '134px' }}
                            onClick={() => toggleShowWidgetType(false)}
                        />
                        <Button
                            label="Continue"
                            cssClass="primary regular"
                            style={{ width: '134px' }}
                            onClick={() => toggleShowWidgetType(true)}
                        />
                    </ModalFooter>
                </div>
            </Modal>
        )
    }
}

export default WidgetType
